import { render, staticRenderFns } from "./DiscountShow.vue?vue&type=template&id=3567d2de"
import script from "./DiscountShow.vue?vue&type=script&lang=js"
export * from "./DiscountShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports